import cc from 'classcat';
import { useFormikContext, Form } from 'formik';

import Button from '../../../components/Button';
import PasswordInputs from '../PasswordInputs';
import Payment from '../Payment';

import styles from './styles.module.scss';

export default function PaymentAndRegistrationForm({
  children,
  className,
  ctaDisabled,
  ctaLabel,
  isAdHocMembershipOrder,
  order,
  requiresRegistration,
  savePaymentLabel,
  setBraintreeInstance,
  setPaymentMethodReady,
  theme,
  token,
}) {
  const {
    isSubmitting,
    isValid,
    values: { password, passwordConfirmation, storeInVault },
  } = useFormikContext();

  const { amountDue, requiresPaymentMethod, requiresStoreInVault } = order;

  return (
    <Form className={cc([styles.container, className])}>
      {requiresPaymentMethod && (
        <Payment
          amountDue={amountDue}
          isAdHocMembershipOrder={isAdHocMembershipOrder}
          requiresStoreInVault={requiresStoreInVault}
          savePaymentLabel={savePaymentLabel}
          setBraintreeInstance={setBraintreeInstance}
          setPaymentMethodReady={setPaymentMethodReady}
          storeInVault={storeInVault}
          theme={theme}
          token={token}
        />
      )}
      {children}
      {requiresRegistration && (
        <PasswordInputs
          password={password}
          passwordConfirmation={passwordConfirmation}
          isSubmitting={isSubmitting}
        />
      )}

      <Button
        theme={theme}
        disabled={ctaDisabled || !isValid || isSubmitting}
        className={styles.cta}
      >
        {ctaLabel}
      </Button>
    </Form>
  );
}
